(() => {
  'use strict';
  const script = document.currentScript;
  const label = script?.dataset.advisorLabel;
  const avatar = script?.dataset.advisorAvatar;
  if (!label || !avatar) return;
  const styleId = 'nl-shopify-inbox-chat-theme';
  const watchedRoots = new WeakSet();
  const font = getComputedStyle(document.body).fontFamily;
  const css = `
    .nl-advisor-avatar {display:none!important}
    button.nl-advisor-launcher {
      display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:10px!important;
      box-sizing:border-box!important;width:auto!important;min-width:0!important;max-width:calc(100vw - 32px)!important;
      height:56px!important;min-height:56px!important;padding:6px 18px 6px 6px!important;
      border:1px solid #496455!important;border-radius:30px!important;background:#294537!important;color:#fffdf7!important;
      font-family:var(--nl-advisor-font)!important;font-size:14px!important;font-weight:600!important;line-height:1.3!important;letter-spacing:0!important;
      box-shadow:0 5px 18px rgba(27,45,35,.16)!important;transition:background-color .16s ease,box-shadow .16s ease!important;
    }
    button.nl-advisor-launcher:hover {background:#203b2d!important;box-shadow:0 7px 22px rgba(27,45,35,.19)!important}
    button.nl-advisor-launcher:focus-visible {outline:2px solid #294537!important;outline-offset:4px!important}
    button.nl-advisor-launcher .activator__icon {display:none!important}
    button.nl-advisor-launcher .activator__label {display:block!important;margin:0!important;padding:0!important;color:inherit!important;font:inherit!important;white-space:nowrap!important}
    button.nl-advisor-launcher .nl-advisor-avatar {display:block!important;flex:0 0 42px;width:42px!important;height:42px!important;border:1px solid rgba(255,253,247,.45);border-radius:50%!important;object-fit:cover;object-position:center 38%;background:#eee8dc;box-sizing:border-box}
    @media(max-width:767px) {
      button.nl-advisor-launcher {position:fixed!important;right:12px!important;bottom:calc(12px + env(safe-area-inset-bottom))!important;height:54px!important;min-height:54px!important;padding-right:16px!important;font-size:13px!important}
      button.nl-advisor-launcher .nl-advisor-avatar {width:40px!important;height:40px!important;flex-basis:40px}
    }
    @media(prefers-reduced-motion:reduce) {button.nl-advisor-launcher {transition:none!important}}
  `;
  function decorate(root, host) {
    let style = root.getElementById(styleId);
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.append(style);
    }
    root.querySelectorAll('button[part~="activator"]').forEach(button => {
      const closed = !host.hasAttribute('open') && button.getAttribute('aria-expanded') !== 'true';
      button.classList.toggle('nl-advisor-launcher', closed);
      if (!closed) return;
      const text = button.querySelector('.activator__label');
      if (!text) return;
      if (text.textContent !== label) text.textContent = label;
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (!button.querySelector('.nl-advisor-avatar')) {
        const img = document.createElement('img');
        img.className = 'nl-advisor-avatar';
        img.src = avatar;
        img.alt = '';
        img.width = 42;
        img.height = 42;
        img.setAttribute('aria-hidden', 'true');
        button.prepend(img);
      }
    });
  }
  function watch(root, host) {
    if (!watchedRoots.has(root)) {
      watchedRoots.add(root);
      let queued = false;
      const observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => {queued = false;watch(root, host);});
      });
      observer.observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['aria-label','aria-expanded']});
    }
    decorate(root, host);
    root.querySelectorAll('shopify-agent-runtime').forEach(runtime => {
      if (runtime.shadowRoot) watch(runtime.shadowRoot, host);
    });
  }
  function scan() {
    document.querySelectorAll('shopify-chat').forEach(host => {
      host.style.setProperty('--nl-advisor-font', font);
      if (host.shadowRoot) watch(host.shadowRoot, host);
    });
  }
  const observer = new MutationObserver(entries => {
    const relevant = entries.some(entry => entry.type === 'attributes' && entry.target.matches('shopify-chat') || [...entry.addedNodes].some(node => node.nodeType === 1 && (node.matches('shopify-chat') || node.querySelector('shopify-chat'))));
    if (relevant) scan();
  });
  observer.observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['open']});
  customElements.whenDefined('shopify-chat').then(scan);
  customElements.whenDefined('shopify-agent-runtime').then(scan);
  scan();
})();
